// RequireAuth.js
import { useLocation, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

export function RequireAuth({ children }) {
  const location = useLocation();
  const { route } = useAuthenticator((context) => [context.route]);
  const encodedURI = encodeURIComponent(`${location.pathname}${location.search}`)
  if (route !== 'authenticated' && route !== 'idle') {
    return <Navigate to={`/signin?redirectUri=${encodedURI}`} state={{ from: location }} replace />;
  }
  if (route !== 'authenticated') {
    return (<div>Loading...</div>)
  } else {
    return children;
  }

}